module.exports = __webpack_public_path__ + "img/feature4.29355aaf.png";